import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-instalacao-minima-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-header">
      <h5 class="modal-title">Lista de Instalações Mínimas</h5>
    </div>
    <div class="modal-body" style="overflow-x: auto">
      <div [innerHTML]="dsInstalacaoMinima"></div>
    </div>
    <div class="modal-footer">
      <button type="button" class="br-button secondary" (click)="activeModal.dismiss()">Fechar</button>
    </div>
  `,
})
export class InstalacaoMinimaModalComponent {
  activeModal = inject(NgbActiveModal);
  dsInstalacaoMinima = '';
}
